import { TurnMargins } from "@pdfking/filling-flex"
import type { Distance, Margins } from "@pdfking/math"
import { FlipMargins } from "@pdfking/math"

import type { ImpositionNode } from "#internal"

/** Margins given in `node`'s own frame, read on the sheet where it landed:
 * turned over with it on a rear — left for right — then turned with it. */
export const SheetMargins = (
  node: Pick<ImpositionNode, "is_front" | "rotation">,
  margins: Margins<Distance>
): Margins<Distance> =>
  TurnMargins(node.is_front ? margins : FlipMargins(margins, "x"), node.rotation)
